import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("europedu_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Tenant-Slug"] = localStorage.getItem("europedu_tenant") || "europedu";
  return config;
});

export const money = (pence, currency = "GBP") =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency }).format((pence || 0) / 100);

export const SPONSORSHIP_LABELS = {
  sponsorship_confirmed: { text: "Sponsorship confirmed", cls: "bg-emerald-50 text-emerald-700" },
  sponsorship_considered: { text: "Sponsorship considered", cls: "bg-sky-50 text-sky-700" },
  licensed_employer: { text: "Licensed employer", cls: "bg-blue-50 text-blue-800" },
  sponsorship_history_observed: { text: "Sponsorship history observed", cls: "bg-indigo-50 text-indigo-700" },
  sponsorship_unlikely: { text: "Sponsorship unlikely", cls: "bg-amber-50 text-amber-800" },
  not_established: { text: "Not established", cls: "bg-slate-100 text-slate-700" },
};
